import * as React from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';

type PasswordlessResultPageProps = {
  /**
   * Boolean representing whether the passwordless login request succeeded
   */
  hasSucceeded: boolean;
  /**
   * Email of the user requesting a passwordless login
   */
  email: string;
  /**
   * Name of the account form in analytics events, should be unique within the app
   * Convention: {appName}-{accountFormName}
   */
  analyticsName: string;
};

const PasswordlessResultPage = ({
  email,
  hasSucceeded,
  analyticsName,
}: PasswordlessResultPageProps) => {
  return (
    <Box width="100%" py="$36x" px="$12x" gap="$10x" $largerThanSM={{ width: 480 }}>
      <Text tag="h1" typography="$headerMedium">
        {hasSucceeded ? 'Check your email' : 'Something went wrong.'}
      </Text>
      <Text tag="p" typography="$bodySmall">
        {hasSucceeded ? (
          <>
            We sent an email to{' '}
            <Text tag="span" typography="$bodySmall">
              {email}
            </Text>
            . It includes a link that will sign you in.
          </>
        ) : (
          <>
            We are unable to send you an email. Please reach out to{' '}
            <Link
              typography="$bodySmall"
              variant="secondary"
              href="mailto:contact@opendoor.com"
              onPress={() => {}}
              aria-label={null}
              analyticsName={`${analyticsName}-passwordless-error-contact-us`}
            >
              contact@opendoor.com
            </Link>{' '}
            for support
          </>
        )}
      </Text>
    </Box>
  );
};

export default PasswordlessResultPage;
